import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/e0f9f4aa9db12d5d6dd1c6c6067d52eb.jpg"
              alt="Bellport Branding"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Professional short-form video editing for creators, brands, and businesses on Long Island and beyond.
            </p>
            <a
              href="tel:6315675656"
              className="text-[#1E3A8A] font-semibold hover:text-[#1E3A8A]/80 transition-colors cursor-pointer"
            >
              (631) 567-5656
            </a>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/video-editing" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Video Editing
                </Link>
              </li>
              <li>
                <Link to="/videography" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Video Production
                </Link>
              </li>
              <li>
                <Link to="/website-design" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Website Design
                </Link>
              </li>
              <li>
                <Link to="/ethical-hacking" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Ethical Hacking
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4">Service Areas</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/website-design-development-patchogue-ny" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Patchogue
                </Link>
              </li>
              <li>
                <Link to="/website-design-development-bellport-ny" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Bellport
                </Link>
              </li>
              <li>
                <span className="text-gray-600 text-sm">All of Long Island</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@bellportbranding.com"
                  className="text-gray-600 hover:text-[#1E3A8A] transition-colors text-sm cursor-pointer"
                >
                  info@bellportbranding.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} Bellport Branding. All rights reserved.
          </p>
          <a
            href="https://www.instagram.com/danmcbabe/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-gray-500 hover:text-gray-700 transition-colors text-sm cursor-pointer"
          >
            Designed by @danmcbabe
          </a>
        </div>
      </div>
    </footer>
  );
}
